import React, { useEffect, useState } from "react";
import useAttendee from "containers/attendee/useHooks";
import useUtils from "hooks/useUtils";
import { ReviewFilterDTO } from "utils/helpers/models/attendee/review-filter-dto";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { TiStarFullOutline } from "react-icons/ti";
import { useSelector } from "react-redux";
import noFoundGif from "assets/images/gifs/noFoundGif.gif";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";

const Reviews = () => {
  const { getHostReviews } = useAttendee();
  const { getQueryParams } = useUtils();
  const { id: hostId } = getQueryParams();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const [data, setData] = useState<any[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const [filters, setFilters] = useState<Partial<ReviewFilterDTO>>({
    page: 1,
    totalPages: 1,
    size: 15,
    hostId,
  });
  const getAllEvents = (filters: Partial<ReviewFilterDTO>) => {
    const isFirstPage = filters.page === 1;
    getHostReviews(
      setData,
      { ...filters, page: filters.page - 1 },
      isFirstPage ? [] : data,
      setFilters
    );
    setFilters({ ...filters });
    
    // Mark initial load as complete after first API call
    if (isInitialLoad && isFirstPage) {
      setIsInitialLoad(false);
    }
  };

  useEffect(() => {
    getAllEvents(filters);
  }, []);

  return (
    <div className="my-10">
      <div className="border-[0.3px] border-labelTextColor  p-6  rounded-lg shadow-sm flex flex-col gap-10">
        {data?.map((review: any) => (
          <div
            key={review.id}
            className="flex md:flex-nowrap flex-wrap items-start justify-between "
          >
            <div className="flex flex-col gap-3 w-full">
              <div className="flex items-center gap-2">
                <img
                  src={concatPathWithBackendUrl(
                    review.user.profilePicUrl.fileDownloadUri
                  )}
                  alt="Avatar"
                  className="w-10 h-10 rounded-full"
                />
                <div>
                  <h4 className="font-semibold text-black text-lg">
                    {review.user.firstName} {review.user.lastName}
                  </h4>
                  <p className="text-sm text-labelTextColor">{review.date}</p>
                </div>
              </div>

              <div>
                <p className="text-blackie">{review.comment}</p>
              </div>
            </div>
            <div className="flex flex-col gap-2 md:gap-3 md:items-end md:px-6 mt-3">
              {/* Rating */}
              <div className="flex items-center space-x-2">
                {[...Array(5)].map((_, i) => (
                  <TiStarFullOutline
                    key={i}
                    className={`w-4 h-4 ${
                      i < review.rating ? "text-yellow-500" : "text-gray-300"
                    }`}
                  />
                ))}
                <span className="ml-2 text-labelTextColor">
                  ({review.rating})
                </span>
              </div>
            </div>
          </div>
        ))}
     
      <div className="my-10">
        <CustomMessageDisplay
          show={!isLoading && !data.length && !isInitialLoad}
          title="No Reviews Yet"
          slogan="This host hasn't received any reviews yet. Be the first to share your experience!"
          image={noFoundGif}
          imageAlt="No reviews found"
          className="py-12"
          imageClassName="w-24 h-24"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      </div>

      </div>
      {filters.totalPages > filters.page && (
        <div className="text-center mt-10">
          <button
            className="px-6 py-2 bg-fade text-primaryBlueText rounded-full"
            onClick={() => getAllEvents({ ...filters, page: filters.page + 1 })}
          >
            See More
          </button>
        </div>
      )}
    </div>
  );
};

export default Reviews;
